<template>
    <div class="depot">
        <headerNotice routerName="优惠券列表"></headerNotice>
        <!-- 搜索框 -->
        <div class="seach-box">
            <h2 class="title">
                <i></i>
                <span>筛选查询</span>
            </h2>
            <div class="input-wrapper">
                <el-row :gutter="24">
                    <!-- 輸入框 -->
                    <el-col :span="10" :offset="0">
                        <div>
                            <span>优惠券名称：</span>
                            <el-input class="el-search" v-model="promotionName" placeholder></el-input>
                        </div>
                    </el-col>
                    <!-- 状态选择 -->
                    <el-col :span="12" :offset="0">
                        <div class="status">
                            <span>状态：</span>
                            <el-select v-model="stateValue" @change="selectGet" placeholder="全部">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <!-- 查询按钮 -->
                    <el-col :span="2" :offset="0">
                        <div class="status">
                            <el-button type="primary" @click="searchConfirm">查询</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 促销列表 -->
        <div class="depot-list">
            <div class="head">
                <h2 class="title">
                    <i></i>
                    <span>促销列表</span>
                </h2>
                <div class="control">
                    <el-button class="tip-box" @click="toAddRedution">添加</el-button>
                </div>
            </div>
            <!-- 添加Dialog框 -->
            <div class="add-box" v-loading="loading">
                <el-dialog
                    width="600px"
                    :title="title"
                    :visible.sync="showAddBox"
                    @close="closeDialog"
                >
                    <el-form class="from-el" :model="formData">
                        <el-form-item :rules="{required: true}" label="优惠券名称:" label-width="138px">
                            <el-input
                                placeholder="不能为空，1~20个字符"
                                class="input-el"
                                v-model="formData.couponName"
                                autocomplete="off"
                                maxlength="20"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="面值:" label-width="138px">
                            <el-input
                                :readonly="readonly"
                                placeholder="请输入金额"
                                class="input-el"
                                v-model="formData.abate"
                                autocomplete="off"
                                type="number"
                            >
                                <template slot="prepend">￥</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="发放总量:" label-width="138px">
                            <el-input
                                :readonly="readonly"
                                placeholder="只能输入正整数"
                                class="input-el"
                                v-model="formData.total"
                                autocomplete="off"
                                type="number"
                                @blur="limitPositiveInteger1($event)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="每人限领:" label-width="140px">
                            <el-radio-group v-model="formData.limit">
                                <el-radio :label="1">不限制</el-radio>
                                <el-radio :label="2">限制</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="设置数量:"
                            label-width="138px"
                            v-if="formData.limit == 2"
                        >
                            <el-input
                                :readonly="readonly"
                                placeholder="只能输入正整数"
                                class="input-el"
                                v-model="formData.limitCount"
                                autocomplete="off"
                                type="number"
                                @blur="limitPositiveInteger2($event)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="订单金额:" label-width="140px">
                            <el-radio-group v-model="formData.cash">
                                <el-radio :label="1">不限制</el-radio>
                                <el-radio :label="2">限制</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="设置金额:"
                            label-width="138px"
                            v-if="formData.cash == 2"
                        >
                            <el-input
                                :readonly="readonly"
                                placeholder="只能输入正整数"
                                class="input-el"
                                v-model="formData.reach"
                                autocomplete="off"
                                type="number"
                                @blur="limitPositiveInteger3($event)"
                            >
                                <template slot="prepend">满</template>
                                <template slot="append">元使用</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="有效期:" label-width="138px">
                            <el-date-picker
                                :readonly="readonly"
                                v-model="formData.dateTime"
                                type="datetimerange"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions2"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="活动商品:" label-width="140px">
                            <el-radio-group v-model="formData.scope">
                                <el-radio :label="1">全场通用</el-radio>
                                <el-radio :label="2">指定商品</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="商品制定:"
                            label-width="140px"
                            v-if="formData.scope == 2"
                        >
                            <el-button style="margin-right:35px;" @click="openShowGoods();">选择商品</el-button>
                            已选择
                            {{goodsNum}}个商品
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showAddBox = false">取 消</el-button>
                        <el-button type="primary" @click="addFullReduction(state)">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 商品选择Dialog框 -->
            <div class="add-box">
                <el-dialog width="700px" title="选择商品:" :visible.sync="showGoods">
                    <el-form class="from-el" :model="goodsForm">
                        <!-- 搜索Dialog框 -->
                        <el-col :span="12" :offset="0">
                            <el-input placeholder="商品名称/商品编码" v-model="goodsForm.keyword">
                                <el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button>
                            </el-input>
                        </el-col>
                        <el-table
                            ref="multipleTablesp"
                            :data="goodsList"
                            style="width: 100%"
                            :default-sort="{prop: 'date', order: 'descending'}"
                            @selection-change="handleCustomerSelectionChange"
                            v-loading="dialogLoading"
                        >
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="title" label="商品名称" width="300"></el-table-column>
                            <el-table-column prop="propName" label="规格名称"></el-table-column>
                            <el-table-column prop="itemCode" label="规格编码"></el-table-column>
                            <el-table-column prop="price" label="价格"></el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                            class="pagination"
                            @size-change="handleCustomeSizeChange"
                            @current-change="handleCustomerCurrentChange"
                            :page-sizes="[25, 50, 75, 100]"
                            layout="total, sizes, next"
                            :background="true"
                            next-text="点击加载更多⇣⇣"
                            :total="customerTotalCount"
                        ></el-pagination>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showGoods = false">取 消</el-button>
                        <el-button type="primary" @click="getGoodsNum">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 活动详情Dialog框 -->
            <div class="add-box">
                <el-dialog width="700px" title="活动详情:" :visible.sync="showActivity">
                    <el-form class="from-el" :model="activityForm">
                        <!-- 搜索Dialog框 -->
                        <!-- 輸入框 -->
                        <el-col :span="8" :offset="0">
                            <div class="status">
                                <span>订单编号：</span>
                                <el-input
                                    style="width:60%;"
                                    class="el-search"
                                    v-model="orderNumber"
                                    placeholder="请输入编号"
                                ></el-input>
                            </div>
                        </el-col>
                        <!-- 状态选择 -->
                        <el-col :span="12" :offset="0">
                            <div class="status">
                                <span>状态：</span>
                                <el-select
                                    v-model="activityValue"
                                    @change="selectGetVal"
                                    placeholder="全部"
                                >
                                    <el-option
                                        v-for="item in activityOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <!-- 查询按钮 -->
                        <el-col :span="2" :offset="0">
                            <div class="status">
                                <el-button type="primary" @click="searchConfirmActivity">查询</el-button>
                            </div>
                        </el-col>
                        <el-table
                            ref="multipleTable"
                            :data="activityList"
                            style="width: 100%"
                            :default-sort="{prop: 'date', order: 'descending'}"
                            v-loading="dialogLoading"
                        >
                            <el-table-column prop="userName" label="领取会员"></el-table-column>
                            <el-table-column prop="amount" label="面值"></el-table-column>
                            <el-table-column prop="createTime" label="领取日期"></el-table-column>
                            <el-table-column prop="useTime" label="使用日期"></el-table-column>
                            <el-table-column prop="orderCode" label="订单编号"></el-table-column>
                            <el-table-column prop="status" label="状态"></el-table-column>
                        </el-table>
                        <!--分页-->
                        <div class="pagination-wrapper">
                            <el-pagination
                                @size-change="handleActivitySizeChange"
                                @current-change="handleActivityCurrentChange"
                                :current-page.sync="currentPage1"
                                :page-sizes="[10, 20, 30, 40]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="activityTotalCount"
                                center
                            ></el-pagination>
                        </div>
                    </el-form>
                </el-dialog>
            </div>
            <!-- 促销优惠券列表 -->
            <div class="dataTable" v-loading="loading">
                <el-table
                    ref="singleTable"
                    :data="subtractionList"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    :default-sort="{prop: 'date', order: 'descending'}"
                >
                    <el-table-column property="couponName" prop="couponName" label="优惠券名称"></el-table-column>
                    <el-table-column property="abate" prop="abate" label="面值（元）"></el-table-column>
                    <el-table-column property="reach" prop="reach" label="使用条件"></el-table-column>
                    <el-table-column property="timer" label="有效期">
                        <template slot-scope="scope">{{scope.row.startTime}}至{{scope.row.endTime}}</template>
                    </el-table-column>
                    <el-table-column property="remainderCount" prop="remainderCount" label="剩余数量"></el-table-column>
                    <el-table-column property="userCount" label="领取人/张">
                        <template
                            slot-scope="scope"
                        >{{scope.row.userCount}}/{{scope.row.receiveCount}}</template>
                    </el-table-column>
                    <el-table-column
                        property="alreadyUsedCount"
                        prop="alreadyUsedCount"
                        label="已使用"
                    ></el-table-column>
                    <el-table-column property="state" prop="state" label="状态"></el-table-column>
                    <el-table-column align="center" prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click="editFullReduction(scope.row.couponID)"
                            >编辑</el-button>
                            <el-button
                                type="text"
                                size="small"
                                :disabled="scope.row.state == '已过期'"
                                @click="prohibitSales(scope.row)"
                            >使失效</el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="getActivity(params,scope.row.couponID)"
                            >活动详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--分页-->
        <div class="pagination-wrapper">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                center
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            params: {},
            title: "添加优惠券:", //控制弹窗标题
            state: true,
            readonly: false, // 编辑时部分数据设置只读
            index: 0,
            dialogLoading: true,
            loading: true,
            totalCount: 0,
            currentPage: 1,
            currentPage1: 1,
            input: "",
            maxResultCount: 25, //默认一页显示的个数,
            subtractionList: [], //优惠券表列表主数据
            promotionName: "", //优惠券名称
            stateValue: "", //优惠券状态
            stateVal: 0, //优惠券状态值
            orderNumber: "", //活动详情订单编号
            activityValue: "", //活动详情状态
            activityVal: -1, //活动详情状态值
            formData: {
                couponName: "",
                total: 0,
                limitCount: 0,
                startTime: "",
                endTime: "",
                remark: "",
                reach: 0,
                abate: 0,
                scope: 1,
                cash: 1,
                limit: 1,
                itemPropIDs: []
            },
            reginData: [], //区域数据
            defaultProps: {
                children: "children",
                label: "name"
            },
            checkedReginData: [], //屏蔽区域已选数据
            defaultKeys: [],
            areaNumber: 0, // 选中地区数量
            goodsNum: 0, // 选中商品数量
            goodsList: [], // 商品列表
            activityList: [], // 活动详细列表
            choosedItem: [], //已选择的商品列表
            goodsForm: {},
            activityForm: {},
            showAddBox: false, //是否展示添加弹出框
            showArea: false, // 是否展示地区列表弹出框
            showGoods: false, // 是否展示商品列表弹出框
            showActivity: false, // 是否展示活动详细列表弹出框
            couponID: 0, // 点击详情时获取index
            itemPropIDs: [], // 点击详情时获取选中商品
            chooseCustomerData: [], //所有选中的客户数据
            currentPageCustomer: [], //所有页选中的商品数据
            nowCurrentPageCustomer: [], //当前页选中的商品数据
            chooseActivityData: [], //所有选中的活动详细数据
            currentPageActivity: [], //当前页选中的活动详细数据
            customerTotalCount: 0,
            activityTotalCount: 0,
            options: [
                {
                    value: "0",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "未生效"
                },
                {
                    value: "2",
                    label: "进行中"
                },
                {
                    value: "3",
                    label: "已过期"
                }
            ],
            activityOptions: [
                {
                    value: "0",
                    label: "未使用"
                },
                {
                    value: "2",
                    label: "已使用"
                }
            ],
            pickerOptions2: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            checkAll: false,
            cities: cityOptions,
            multipleSelection: []
        };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
            Status: 0
        });
        this.getGoods(
            {
                MaxResultCount: this.maxResultCount
            },
            true
        );
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/Coupon/GetList",
                params: params,
                success(res) {
                    for (var i = 0; i < res.items.length; i++) {
                        if (res.items[i].state == 1) {
                            res.items[i].state = "未生效";
                        } else if (res.items[i].state == 2) {
                            res.items[i].state = "促销中";
                        } else {
                            res.items[i].state = "已过期";
                        }
                    }
                    self.subtractionList = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 下拉框value值获取
        selectGet(vId) {
            this.stateVal = vId;
        },
        //名称 状态 日期条件查询
        searchConfirm() {
            this.getDatas({
                MaxResultCount: this.maxResultCount,
                OrderCode: this.orderNumber, //优惠券名称
                Status: this.stateVal //优惠券状态
            });
            this.currentPage = 1;
        },
        // 限制输入正整数1
        limitPositiveInteger1(e) {
            let boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value);
            if (!boolean) {
                this.$message.warning("请输入正整数！");
                this.formData.total = "";
            }
        },
        // 限制输入正整数2
        limitPositiveInteger2(e) {
            let boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value);
            if (!boolean) {
                this.$message.warning("请输入正整数！");
                this.formData.limitCount = "";
            }
        },
        // 限制输入正整数3
        limitPositiveInteger3(e) {
            let boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value);
            if (!boolean) {
                this.$message.warning("请输入正整数！");
                this.formData.reach = "";
            }
        },
        //添加或编辑优惠券
        addFullReduction(state) {
            let self = this;
            if (self.$refs.multipleTablesp) {
                self.$refs.multipleTablesp.clearSelection();
            }
            self.readonly = false;
            self.btnLoading = true;
            if (self.state == true) {
                if (
                    !self.formData.couponName ||
                    !self.formData.abate ||
                    !self.formData.total ||
                    !self.formData.dateTime
                ) {
                    self.$message.error("请检查必填项是否填写！");
                    self.btnLoading = false;
                    return;
                }
                self.title = "添加优惠券:";
                let setData = {
                    couponName: self.formData.couponName,
                    total: self.formData.total,
                    limitCount: self.formData.limitCount,
                    startTime: self.formData.dateTime[0],
                    endTime: self.formData.dateTime[1],
                    remark: "",
                    reach: self.formData.reach,
                    abate: self.formData.abate,
                    scope: self.formData.scope,
                    itemPropIDs: self.formData.itemPropIDs
                };
                $http.POST({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/Coupon/Create",
                    data: setData,
                    success(res) {
                        self.$message({
                            message: "添加成功",
                            type: "success"
                        });
                        let params = {
                            MaxResultCount: self.maxResultCount
                        };
                        self.getDatas(params);
                        self.currentPage = 1;
                        self.btnLoading = false;
                        self.showAddBox = false;
                    },
                    fail(res) {
                        self.btnLoading = false;
                        self.showAddBox = false;
                    }
                });
            } else {
                if (!self.formData.couponName) {
                    self.$message.error("请检查必填项是否填写！");
                    self.btnLoading = false;
                    return;
                }
                // self.title = "编辑优惠券:";
                let updateData = {
                    couponID: self.couponID,
                    couponName: self.formData.couponName,
                    limitCount: self.formData.limitCount,
                    scope: self.formData.scope,
                    itemPropIDs: self.formData.itemPropIDs
                };
                console.log(updateData);
                $http.PUT({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/Coupon/Update",
                    data: updateData,
                    success(res) {
                        self.$message({
                            message: "修改成功",
                            type: "success"
                        });
                        let params = {
                            MaxResultCount: self.maxResultCount
                        };
                        self.getDatas(params);
                        self.currentPage = 1;
                        self.btnLoading = false;
                        self.showAddBox = false;
                        self.state = true; // 保存编辑完毕修改确认按钮参数
                    },
                    fail(res) {
                        self.btnLoading = false;
                        self.showAddBox = false;
                        self.state = true;
                    }
                });
            }
        },
        // 添加优惠
        toAddRedution() {
            let self = this;
            self.state = true; // 如果是编辑则确认按钮更改为保存编辑
            self.showAddBox = true;
            self.readonly = false; // 添加时关闭只读
            self.title = "添加优惠券:";
        },
        // 获取优惠券详细
        editFullReduction(row) {
            let self = this;
            self.state = false; // 如果是编辑则确认按钮更改为保存编辑
            self.couponID = row; // 获取优惠券列表id
            self.showAddBox = true;
            self.readonly = true; // 编辑时设置部分数据只读
            self.title = "编辑优惠券:";
            // 初始化商品列表
            // self.showGoods = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/Coupon/GetDetail",
                params: {
                    couponID: self.couponID
                },
                success(res) {
                    console.log(res);
                    let limit = null;
                    let cash = null;
                    if (res.limitCount == 0) {
                        limit = 1;
                    } else {
                        limit = 2;
                    }
                    if (res.reach == 0) {
                        cash = 1;
                    } else {
                        cash = 2;
                    }
                    self.formData = {
                        // 获取满减数据
                        cash: cash,
                        limit: limit,
                        couponName: res.couponName,
                        total: res.total,
                        abate: res.abate,
                        limitCount: res.limitCount,
                        reach: res.reach,
                        scope: res.scope,
                        itemPropIDs: res.itemPropIDs,
                        dateTime: [res.startTime, res.endTime]
                    };
                    self.itemPropIDs = res.itemPropIDs;
                    self.goodsNum = res.itemPropIDs.length; // 获取选中商品数量
                    if (Number(self.goodsNum) > 25) {
                        let params = {
                            MaxResultCount: self.goodsNum,
                            couponID: self.couponID
                        };
                        self.getSelectedData(params, true);
                    } else {
                        let params = {
                            MaxResultCount: 25,
                            couponID: self.couponID
                        };
                        self.getSelectedData(params, true);
                    }
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 添加或编辑弹出框关闭时清除数据
        closeDialog() {
            let self = this;
            self.formData = {
                couponName: "",
                total: 0,
                limitCount: 0,
                startTime: "",
                endTime: "",
                remark: "",
                reach: 0,
                abate: 0,
                scope: 0,
                itemPropIDs: []
            };
            self.goodsForm.keyword = "";
            self.currentPageCustomer = [];
            if(self.$refs.multipleTablesp){
                self.$refs.multipleTablesp.clearSelection();
            }
            // 重新初始化商品列表
            this.getGoods({
                MaxResultCount: this.maxResultCount
            }, true);
        },
        //获取编辑时已选中商品
        getSelectedData(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/Coupon/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.goodsList = res.items;
                    } else {
                        self.goodsList = self.goodsList.concat(res.items);
                    }
                    // //自动勾选接口返回已选中的客户
                    let timer = setTimeout(() => {
                        self.goodsList.forEach((ele, index) => {
                            if (ele.checked) {
                                if (self.$refs.multipleTablesp) {
                                    self.$refs.multipleTablesp.toggleRowSelection(
                                        ele,
                                        true
                                    );
                                }
                                clearTimeout(timer);
                                timer = null;
                            }
                        });
                    }, 100);
                    timer = setTimeout(() => {
                        self.goodsList.forEach((ele1, index1) => {
                            self.currentPageCustomer.forEach((ele2, index2) => {
                                if (ele1.propID == ele2.propID) {
                                    self.$refs.multipleTablesp.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                    clearTimeout(timer);
                                    timer = null;
                                }
                            });
                        });
                    }, 10);
                    self.customerTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        openShowGoods() {
            let self = this;
            this.showGoods = true;
            let timer = setTimeout(() => {
                self.goodsList.forEach((ele, index) => {
                    if (ele.checked) {
                        if (self.$refs.multipleTablesp) {
                            self.$refs.multipleTablesp.toggleRowSelection(
                                ele,
                                true
                            );
                        }
                        clearTimeout(timer);
                        timer = null;
                    }
                });
            }, 100);
            timer = setTimeout(() => {
                self.goodsList.forEach((ele1, index1) => {
                    self.currentPageCustomer.forEach((ele2, index2) => {
                        if (ele1.propID == ele2.propID) {
                            self.$refs.multipleTablesp.toggleRowSelection(
                                ele1,
                                true
                            );
                            clearTimeout(timer);
                            timer = null;
                        }
                    });
                });
            }, 50);
        },
        //获取商品列表数据
        getGoods(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/Coupon/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.goodsList = res.items;
                    } else {
                        self.goodsList = self.goodsList.concat(res.items);
                    }
                    self.goodsList.forEach((ele1, index1) => {
                        self.currentPageCustomer.forEach((ele2, index2) => {
                            if (ele1.propID == ele2.propID) {
                                setTimeout(() => {
                                    self.$refs.multipleTablesp.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                }, 10);
                            }
                        });
                    });
                    self.customerTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 根据名称/编号/规格/规格编号  查询商品
        searchGoods() {
            let self = this;
            let Word = self.goodsForm.keyword;
            if (status) {
                let params = {
                    Word: Word,
                    MaxResultCount: self.maxResultCount
                };
                self.dialogLoading = true;
                $http.GET({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/Coupon/GetItemPropList",
                    params: params,
                    success(res) {
                        self.goodsList = res.items;
                        self.customerTotalCount = res.totalCount;
                        self.dialogLoading = false;
                    },
                    fail(res) {
                        self.dialogLoading = false;
                    }
                });
            } else {
                let params = {
                    Word: Word,
                    couponID: self.couponID,
                    MaxResultCount: self.maxResultCount
                };
                self.getSelectedData(params, true);
            }
        },
        // 获取选中商品数量
        getGoodsNum() {
            let self = this;
            self.showGoods = false;
            let itemIDArr = [];
            self.nowCurrentPageCustomer.forEach((ele, index) => {
                itemIDArr.push(ele.propID);
            });
            self.goodsNum = itemIDArr.length;
            self.formData.itemPropIDs = itemIDArr;
            console.log(self.formData.itemPropIDs);
        },
        //  禁用满减促销
        prohibitSales(row) {
            let self = this;
            self.dialogLoading = true;
            let params = {
                couponID: row.couponID
            };
            this.$confirm("此操作将让促销失效, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    $http.POST({
                        url:
                            this.$store.state.apiUrl +
                            "/api/services/app/Coupon/Cancel",
                        params: params,
                        success(res) {
                            row.code = res.code;
                            self.$message({
                                message: "促销已失效",
                                type: "success"
                            });
                            self.getDatas({
                                MaxResultCount: this.maxResultCount,
                                Status: 0
                            });
                            self.currentPage = 1;
                        },
                        fail(res) {
                            self.dialogLoading = false;
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消"
                    });
                });
        },
        // 活动详细下拉框value值获取
        selectGetVal(vId) {
            this.activityVal = vId;
        },
        //活动详细条件查询
        searchConfirmActivity() {
            let params = {
                MaxResultCount: this.maxResultCount,
                OrderCode: this.orderNumber, //活动详细订单编号
                Status: this.activityVal //活动详细状态
            };
            this.getActivity(params, "");
            this.currentPage1 = 1;
        },
        //获取活动详细列表数据
        getActivity(params, row) {
            let self = this;
            self.showActivity = true;
            if (row) {
                self.couponID = row; // 获取优惠券列表id
            }
            (params.couponID = self.couponID), //把id赋值到params中
                (self.dialogLoading = true);
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/Coupon/GetReceiveList",
                params: params,
                success(res) {
                    for (var i = 0; i < res.items.length; i++) {
                        if (res.items[i].status == 0) {
                            res.items[i].status = "未使用";
                        } else {
                            res.items[i].status = "已使用";
                        }
                    }
                    self.activityTotalCount = res.totalCount;
                    self.activityList = res.items;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        handleSelectionChange(val) {
            this.choosedItem = val;
        },
        //商品选择Dialog框勾选
        handleCustomerSelectionChange(val) {
            if (val.length > this.currentPageCustomer.length) {
                this.currentPageCustomer = val;
            }
            this.nowCurrentPageCustomer = val;
        },
        // 商品选择Dialog框勾选一页显示多少个
        handleCustomeSizeChange(val) {
            let self = this;
            this.chooseCustomerData = this.chooseCustomerData.concat(
                this.currentPageCustomer
            );
            let Word = self.goodsForm.keyword;
            self.maxResultCount = val;
            let params = {};
            if (self.state) {
                params = {
                    Word: Word,
                    MaxResultCount: val
                };
                self.getGoods(params, true);
            } else {
                params = {
                    Word: Word,
                    couponID: self.couponID,
                    MaxResultCount: val
                };
                self.getSelectedData(params, true);
            }
        },
        // 商品选择Dialog框跳转到指定页
        handleCustomerCurrentChange(val) {
            let self = this;
            this.chooseCustomerData = this.chooseCustomerData.concat(
                this.currentPageCustomer
            );
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {};
            if (self.state) {
                params = {
                    SkipCount: skipCount,
                    MaxResultCount: self.maxResultCount,
                    Word: self.goodsForm.keyword
                };
                self.getGoods(params, false);
            } else {
                params = {
                    Word: self.goodsForm.keyword,
                    couponID: self.couponID,
                    SkipCount: skipCount,
                    MaxResultCount: self.maxResultCount
                };
                self.getSelectedData(params, false);
            }
        },
        // 活动详细Dialog框勾选一页显示多少个
        handleActivitySizeChange(val) {
            let self = this;
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val
            };
            this.getActivity(params);
        },
        // 活动详细Dialog框跳转到指定页
        handleActivityCurrentChange(val) {
            let self = this;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount
            };
            this.getActivity(params);
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount
            };
            this.getDatas(params);
        }
    },
    created() {}
};
</script>
<style lang="scss" scoped>
.depot {
    // 搜索
    .seach-box {
        border: 1px solid rgba(228, 228, 228, 1);
        margin: 20px 50px;
        .title {
            display: flex;
            align-items: center;
            height: 50px;
            font-weight: 400;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding-left: 20px;
            // i:first-child {
            //   width: 18px;
            //   height: 18px;
            //   background: green;
            // }
        }
        .input-wrapper {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 40px;
            .el-search {
                width: 180px;
            }
            .status {
                margin-left: 40px;
            }
        }
    }

    // 仓库列表
    .depot-list {
        margin: 0 50px;
        border: 1px solid rgba(228, 228, 228, 1);
        font-weight: 400;
        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            .title {
                display: flex;
                align-items: center;
                height: 50px;
                font-weight: 400;
                padding-left: 20px;
                // i:first-child {
                //   width: 18px;
                //   height: 18px;
                //   background: green;
                // }
            }
        }
        .control {
            .tip-box {
                width: 80px;
                padding-left: 0;
                padding-right: 0;
                margin-right: 20px;
            }
            .select-box {
                width: 100px;
                margin-left: 20px;
            }
        }
        // 弹出框
        .add-box {
            // width: 600px;
            /deep/ .el-dialog__header {
                display: flex;
                align-items: center;
                padding-top: 14px;
                background: rgba(242, 242, 242, 1);
                font-weight: 700;
            }
            .from-el {
                width: 600px;
            }
            .input-el {
                width: 420px;
            }
        }
    }
    // 分页
    .pagination-wrapper {
        text-align: center;
        margin-top: 20px;
    }
    // 文本框
    .el-textarea {
        width: 80%;
    }
}
</style>